import { Status } from '@bitcine/cinesend-theme/dist'
import { useQuery } from '@tanstack/react-query'
import AirlineDropdown from './airline_dropdown'
import CycleDropdown from './cycle_dropdown'
import { useParams, useNavigate } from 'react-router-dom'

const AirlineCycleDropdowns = () => {
  const { airlineID, cycleID } = useParams()
  const navigate = useNavigate()
  const { data: airlines } = useQuery(['airlines'])

  const setCycle = (id) => navigate(buildPreservedRoute({ airlineID, cycleID: id }))

  const setAirline = (id) => {
    const airline = airlines?.find((airline) => airline.id === id)
    if (!airline || !airline.cycles?.length) return
    if (airline.cycles && airline.cycles.length > 0) {
      navigate(`/airlines/${id}/cycles/${airline.cycles[0].id}/dashboard`)
    } else {
      navigate(`/airlines/${id}`)
    }
  }

  const buildPreservedRoute = ({ airlineID, cycleID, newAirlineID, newCycleID }) => {
    const rest = window.location.pathname.split(/cycles\/\d+/)?.[1] || ''
    const paths = rest.split('/').filter(Boolean)

    // if no cycle provided, send user to "select a cycle" screen
    if (!cycleID && !newCycleID) {
      return `/airlines/${newAirlineID || airlineID}`
    }
    // Use newAirlineID/newCycleID if provided, otherwise fall back to current
    let newRoute = `/airlines/${newAirlineID || airlineID}/cycles/${newCycleID || cycleID}`
    if (paths[0] && isNaN(paths[0])) {
      newRoute += `/${paths[0]}`
      if (paths[1] && isNaN(paths[1])) {
        newRoute += `/${paths[1]}`
      }
    }
    return newRoute
  }

  return (
    <div className='flex items-center justify-center mb-4 border-y border-gray-600 py-4'>
      <Status pending={!airlines} error={!airlines}>
        {airlineID ? (
          <div className='space-y-2 w-full mx-4'>
            <AirlineDropdown airlineID={parseInt(airlineID)} airlines={airlines} setAirline={setAirline} />
            <CycleDropdown airlineID={parseInt(airlineID)} cycleID={parseInt(cycleID)} setCycle={setCycle} />
          </div>
        ) : null}
      </Status>
    </div>
  )
}

export default AirlineCycleDropdowns
